module.exports = __webpack_public_path__ + "img/horizontal_4_1_8003.f481d358.png";